module.exports = __webpack_public_path__ + "img/card_store.d5a36622.png";